import { transactions } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const transection_list_view = () => axiosAuthInstance.get(transactions.transection_list_view);
